let language = {
    ADD_ADDRESS_FORM_ADD_TEXT: "添加地址",
    ADD_ADDRESS_FORM_EDIT_TEXT: "编辑",
};

export { language }